import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Role } from '../models/role.model';
import { MENU_ITEMS } from '../config/menu.config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  menuItems: any[] = [];

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    const role = this.authService.getUserRole() as Role | null;
    this.menuItems = role ? MENU_ITEMS[role] || [] : [];
    
  }
}

